import type { ExperienceEntry } from '@/types/content'

/**
 * Reverse-chronological. Add a new role at the top of the array.
 * `summary` is a lead paragraph; `highlights` render as bullets. Use either or both.
 */
export const experience: ExperienceEntry[] = [
  {
    organization: 'Foundation',
    role: 'Mechanical Engineering Intern',
    period: 'January 2026 – Present',
    logo: { src: '/assets/foundation-logo.jpg', alt: 'Foundation logo' },
    summary:
      'Working on the development of dextrous tendon driven robotic hand, focused on sensing ',
  },
  {
    organization: 'Tesla',
    role: 'Robotics Mechanical Design Engineering Intern',
    period: 'September 2025 – December 2025',
    logo: { src: '/assets/tesla-logo.png', alt: 'Tesla logo' },
    summary:
      'Worked under the Optimus mechanical design team, owning component design of Optimus Gen 3 structures',
  },
  {
    organization: 'Tesla',
    role: 'Mechanical Test Engineering Intern',
    period: 'Jan 2025 – May 2025',
    logo: { src: '/assets/tesla-logo.png', alt: 'Tesla logo' },
    summary:
      'Worked with the Optimus Validation team, supporting end to end sub-system structure validation of Optimus Gen 2.5',
  },
  {
    organization: 'Tesla',
    role: 'Mechanical Design Engineering Intern',
    period: 'May 2024 – August 2024',
    logo: { src: '/assets/tesla-logo.png', alt: 'Tesla logo' },
    summary:
      'Worked under Occupant Safety Systems – Seatbelts, where I supported the development and integration of new seatbelt tech for future vehicle programs.',
  },
  {
    organization: 'Tesla',
    role: 'Mechanical Design Engineering Intern',
    period: 'September 2023 – December 2023',
    logo: { src: '/assets/tesla-logo.png', alt: 'Tesla logo' },
    summary:
      'Worked under the Interiors Validation team, supporting the validation and launch of interior trim components.',
  },
  {
    organization: 'University of Waterloo Formula Motorsports',
    role: 'Chassis Member',
    period: 'May 2023 – Present',
    logo: { src: '/assets/logo_UWFE.jpg', alt: 'University of Waterloo Formula Electric logo' },
    highlights: [
      'Designed jigs for the chassis frame, powertrain tabs, and differential tabs that were used to manufacture the 2023 competition vehicle.',
      'Used lathes and milling machines to manufacture jigs for the chassis and powertrain subteams.',
      'Worked on the design and validation of the accumulator mounts for the 2024 UWFE vehicle.',
    ],
  },
  {
    organization: 'Skygauge Robotics',
    role: 'Engineering Intern',
    period: 'January 2023 – May 2023',
    logo: { src: '/assets/skygauge-icon.jpg', alt: 'Skygauge Robotics logo' },
    highlights: [
      'Designed and developed a new packaging system for Q2 drones in SolidWorks, deployed across more than 10 new drones and cutting packaging time by 80%.',
      'Built a drone dashboard with an HTML/CSS/JS frontend to parse backend fleet data, hosted with Nginx and Flask.',
      'Oversaw validation and certification (QI/QC procedures and hardware testing) for the drone flight embedded hardware, leading to a 200% increase in drone production and 70% yield in recommissioned hardware.',
      'Ran regression tests against new software releases to guard flight-critical performance, covering more than 50 update releases across drones, ground control, and hardware.',
      'Conducted root cause analysis on a hardware failure that grounded the entire drone fleet, and implemented the plan that ungrounded more than 10 drones.',
    ],
  },
  {
    organization: 'University of Waterloo Formula Motorsports',
    role: 'Powertrain and Chassis Member',
    period: 'September 2022 – December 2022',
    logo: { src: '/assets/uwfm-logo.png', alt: 'University of Waterloo Formula Motorsports logo' },
    highlights: [
      'Designed jigs for the chassis frame, powertrain tabs, and differential tabs that were used to manufacture the 2023 competition vehicle.',
      'Used lathes and milling machines to manufacture jigs for the chassis and powertrain subteams.',
    ],
  },
  {
    organization: 'FIRST Robotics Competition — Team 1325',
    role: 'General Member',
    period: 'September 2019 – August 2021',
    logo: { src: '/assets/frc1325.png', alt: 'FRC Team 1325 logo' },
    highlights: [
      'Prepared sheet metal part drawings in SolidWorks that were sent to the manufacturer for fabrication.',
      'Machined subassemblies using a bandsaw, drill press, jigsaw, belt sander, and sheet bender, among other tools.',
      'Designed drivetrain systems and custom gearboxes, configuring gear ratios for targeted speed.',
      'Applied parametric sketch design and multibody modelling in SolidWorks.',
    ],
  },
]
